export default "__VITE_ASSET__CiySEY7D__"